const jwtDecode = require('jwt-decode')
import Vue from 'vue'

function buildApiUrl(domain){
  if (!domain) return process.env.VUE_APP_API_SERVER_URL

  const temp =process.env.VUE_APP_API_SERVER_URL.split(':')
  const protocol = temp[0]
  const url = `${protocol}://${domain}`
  const port = temp.slice(-1)[0]
  if (!isNaN(port)){
    return url+':'+port
  }
  return url
}

const state = () => ({
  accessToken: null,
  refreshToken: null,
  apiDomain: null,
  user: null,
  beforePath: null
})

const getters = {
  existToken(state) {
    if (state.accessToken) return true
    return false
  },
  decodedToken(state) {
    const token = state.accessToken
    if (!token) return null
    return jwtDecode(token)
  },
  apiUrl(state){
    return buildApiUrl(state.apiDomain)
  },

  /**
   * テナント管理者かどうか（API 側の is_manager に対応）
   * マイデータ閲覧・ユーザー管理・グループ管理など、テナント管理者限定の判定に使う
   */
  isManager(state) {
    return state.user?.role === 'manager'
  },

  /**
   * 限定指導者かどうか（学生コーチ等。メンバーの個人情報にはアクセス不可）
   */
  isLimitedManager(state) {
    return state.user?.role === 'limited_manager'
  },

  /**
   * テナント管理者または限定指導者かどうか（API 側の is_any_manager に対応）
   * 記録一覧・目標管理・コメントなど指導業務系の判定に使う
   */
  isAnyManager(state, getters) {
    return getters.isManager || getters.isLimitedManager
  },

  accessibleDepartments(state) {
    return state.user?.accessibleDepartments || []
  },

  canAccessEvents(state) {
    return state.user?.department.canAccessEvents || false
  },

  isParentMember(state) {
    return state.user?.role === 'parent' || false
  }
}

const mutations = {
  setAccessToken(state, accessToken) {
    Vue.prototype.$axios.defaults.headers.Authorization = accessToken !== null ? `jwt ${accessToken}` : null
    state.accessToken = accessToken
  },
  setRefreshToken(state, refreshToken) {
    state.refreshToken = refreshToken
  },
  setUser(state, user) {
    state.user = user
  },
  setBeforePath(state, path) {
    state.beforePath = path
  },
  setApiDomain(state, domain){
    state.apiDomain = domain
    Vue.prototype.$axios.defaults.baseURL = buildApiUrl(domain)
  }
}

const actions = {
  /**
   * 今持っている token が有効期限切れかどうかを判定する action
   * tokenが存在しないor有効期限が切れている時に true を返す
   */
  tokenIsExpired({ getters }) {
    const decodedToken = getters.decodedToken
    if (decodedToken === null) return true
    const current = Date.now() / 1000
    const expiration = decodedToken['exp']
    return current > expiration
  },

  async logout({ commit }) {
    commit('setAccessToken', null)
    commit('setRefreshToken', null)
    commit('setUser', null)
    commit('setApiDomain', null)
    return true
  },
  async updateUser({ commit }) {
    const me = await Vue.prototype.$axios.get('/accounts/me/').catch(e => {
      console.error(e)
      return null
    })
    if (!me){
      return false
    }
    commit('setUser', me.data)
    return true
  },

  /**
   * リフレッシュトークンを使用してアクセストークンを更新する
   *
   * @param {*} { state, commit }
   * @returns {boolean} リフレッシュに成功した場合true、失敗した場合false
   */
  async refreshAccessToken({ state, commit }) {
    if (!state.refreshToken) {
      console.warn('リフレッシュトークンが存在しません')
      return false
    }

    try {
      const response = await Vue.prototype.$axios.post('/auth/token/refresh/', {
        refresh: state.refreshToken
      })

      if (response.data && response.data.access && response.data.refresh) {
        commit('setAccessToken', response.data.access)
        commit('setRefreshToken', response.data.refresh)
        console.info('トークンのリフレッシュに成功しました')
        return true
      }

      return false
    } catch (e) {
      console.error('トークンのリフレッシュに失敗しました:', e)
      // リフレッシュトークンも無効な場合はクリアする
      commit('setAccessToken', null)
      commit('setRefreshToken', null)
      return false
    }
  }
  // async login({ commit }, payload) {
  //   const response = await this.$axios
  //     .$post('auth/login/', payload)
  //     .then(res => {
  //       return res.data
  //     })
  //     .catch(e => {
  //       console.error(e)
  //     })

  //   if (response) {
  //     commit('setToken', response.token)
  //     return 'success'
  //   }
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}